export default "__VITE_ASSET__Bjpr8CLs__"